import { render, staticRenderFns } from "./ExpandableTextBlock.vue?vue&type=template&id=30cf38cf&"
import script from "./ExpandableTextBlock.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ExpandableTextBlock.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports